import { PLANV2DETAILS } from '../actionTypes';
import CONSTANTS from '../constants';

const initialState = {
  subscription: [],
  plansDetailsStatus: undefined,
  plansDetailsError: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PLANV2DETAILS.FETCH:
      return {
        ...state,
        plansDetailsStatus: CONSTANTS.API_STATUS.STARTED,
      };
    case PLANV2DETAILS.SUCCESS:
      return {
        ...state,
        ...action.payload,
        plansDetailsStatus: CONSTANTS.API_STATUS.SUCCEEDED,
      };
    case PLANV2DETAILS.FAILED:
      return {
        ...state,
        plansDetailsError: action.payload,
        plansDetailsStatus: CONSTANTS.API_STATUS.FAILED,
      };
    case PLANV2DETAILS.PAYMENTS_SUCCESS:
      return {
        ...state,
        subscription: action.payload,
      };
    default:
      return state;
  }
};
